// src/actions/additionalSectionsActions.js
import api from '../api/axios';
import {
  FETCH_SECTIONS_REQUEST,
  FETCH_SECTIONS_SUCCESS,
  FETCH_SECTIONS_FAILURE,
  UPDATE_SECTION_REQUEST,
  UPDATE_SECTION_SUCCESS,
  UPDATE_SECTION_FAIL,
} from '../constants/additionalSectionsConstants';

export const fetchSections = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_SECTIONS_REQUEST });

    const { data } = await api.get('/sections/my-sections/');

    dispatch({ type: FETCH_SECTIONS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_SECTIONS_FAILURE,
      payload: error.response?.data?.detail || error.message
    });
  }
};

export const updateSection = (section) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_SECTION_REQUEST });

    await api.put(`/sections/my-sections/update/${section.id}/`, section);

    dispatch({ type: UPDATE_SECTION_SUCCESS });
    dispatch(fetchSections());
  } catch (error) {
    dispatch({
      type: UPDATE_SECTION_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};